// import './button.scss';

export { default } from './Button';
export { default as template } from './button.tpl';
